import React from 'react';
var VeltCommentBubbleCommentsCount = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-bubble-comments-count-wireframe", null, children));
};
export default VeltCommentBubbleCommentsCount;
